import * as _ from "lodash";

import {
  _makeJHHApiCall,
  _makeInSecureApiCall,
  IMakeJHHApiCall,
  IMakeInSecureApiCall,
  _getAccessToken,
  _setItemInLocalEncrypted,
  _getItemFromLocalDecrypted,
} from "network-helper";
// import {
//   JHHMainEnv,
//   JHHPatientAppEnv,
//   JHHUploadEnv,
//   JHHCorePlatform,
//   relativePath,
//   fallbackErrorMessage,
//   JHHAppNDHMIntegrationServiceV1,
//   fallbackErrorMessageFor5XXStatusCode,
//   JHHAppIntegrationService,
//   HealthGetTokenUrl,
//   FaqEnv,
// } from "../../Constants/config";
import { _getRefreshToken, _setRequestToken } from "./JHHTokenTS";
// import { EStatus } from "../Enums/generic";
// import { inputParams } from "./GetCommonParam";
// import { forceLogout } from "./ForceLogout";
// import { notify } from "../../Components/Shared/Error/error";
// import { apiErrorIntentHanlder } from "./JsBridgeHelper";
// import { notify } from "./error";
import config from "../config.json";
import { _initalizeClientPublicKey, _makeBifrostApiCall, _setDHRefreshLocalItems } from "bifrost-network-helper";
import { EStatus } from "./Enums/generic";
// import { _setRequestToken } from "./JHHToken";
import { inputParams } from "./GetCommonParam";

const API_ERROR_5XX_REGEX = new RegExp(/^5[0-9]{2}$/);

interface IFailedApiCallType {
  previousRest: IMakeJHHApiCall;
  isJHHTokenRequired: boolean;
  isDeviceDetailsRequired: boolean;
}
const callApiWithRefreshedToken = async (
  result: unknown,
  restDataObject: IFailedApiCallType
) => {
  const status = _.get(result, "status", "");
  if (status === EStatus.SUCCESS) {
    requestTokenCalled = false;
    requestTokenRetry++;
    const accessToken = _getAccessToken();
    _.set(restDataObject.previousRest, "headers.token", accessToken);
    return await handleApiCall(
      restDataObject.previousRest,
      restDataObject.isJHHTokenRequired,
      restDataObject.isDeviceDetailsRequired
    );
  }
};

let requestTokenCalled = false;
let bifrostRequestTokenCalled = false;
let requestTokenRetry = 0;
let awaitTokenPromise: Promise<unknown>;
let awaitBifrostTokenPromise: Promise<unknown>;

export const _setAccessTokenHeader = async () => {
  const result = await _setRequestToken({});
  const status = _.get(result, "status", "");
  const token = _.get(result, "token", "");
  if (status === EStatus.SUCCESS) {
    return token;
  }
};

// const _convertFormDataToJson = (formData: FormData) => {
//   const object: {[key: string]: unknown} = {};
//   formData.forEach((value, key) => object[key as keyof typeof object] = value);
//   return object;
// }

// const _convertJsonToFormData = (jsonObj: {}) => {
//   const formData = new FormData();
//   Object.keys(jsonObj).forEach(key => formData.append(key, jsonObj[key as keyof typeof jsonObj]));
//   return formData;
// }

// const _parseDataObj = (dataObj: {[key: string]: unknown} | FormData) => {
//   let newDataObj: typeof dataObj;
//   if (dataObj instanceof FormData) {
//     newDataObj = _convertFormDataToJson(dataObj)
//   } else {
//     newDataObj = {...dataObj}
//   }
//   Object.entries(newDataObj).forEach(([key, value], i) => {
//     if(value === undefined || value === null) {
//       newDataObj[key as keyof typeof newDataObj] = ""
//     }
//   })
//   if (dataObj instanceof FormData) {
//     return _convertJsonToFormData(newDataObj);
//   } else {
//     return newDataObj;
//   }
// }

export const handleApiCall = async (
  { ...rest }: IMakeJHHApiCall,
  isJHHTokenRequired = false,
  isDeviceDetailsRequired = false,
  skipRequestToken = false
): Promise<any> => {
  try {
    if (isJHHTokenRequired === true) {
      const accessToken =
        _getAccessToken() === null
          ? await _setAccessTokenHeader()
          : _getAccessToken();
      _.set(rest, "headers.token", accessToken);
      _.set(rest, "headers.JIOHH-API-TOKEN", accessToken);
    }
    const EnvArray = [
      // JHHMainEnv,
      config.JHHPatientAppEnv,
      // JHHUploadEnv,
      // JHHCorePlatform,
      // JHHAppNDHMIntegrationServiceV1,
      config.JHHAppIntegrationService,
      config.BifrostBaseUrl
      // FaqEnv
    ];
    if (
      rest.url.length &&
      EnvArray.find((url) => rest.url.includes(url)) !== undefined
    ) {
      if (isDeviceDetailsRequired) {
        rest = {
          ...rest,
          dataObj: {
            ...inputParams(),
            ...rest.dataObj,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...rest.headers,
          },
        };
      } else {
        rest = {
          ...rest,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...rest.headers,
          },
        };
      }
    }
    // if(rest.dataObj) {
    //   rest = {
    //     ...rest,
    //     dataObj: _parseDataObj(rest.dataObj)
    //   }
    // }
    if(requestTokenCalled === true && skipRequestToken === false){
      const result = await awaitTokenPromise;
      const restDataObject = {
        previousRest: rest,
        isJHHTokenRequired: isJHHTokenRequired,
        isDeviceDetailsRequired: isDeviceDetailsRequired,
      };
      return await callApiWithRefreshedToken(result, restDataObject);
    }
    const clonedRest = _.cloneDeep(rest);
    const jhhAPIResponse = await _makeJHHApiCall({ ...clonedRest });
    if (rest.url.indexOf("refresh_token") === -1 && rest.url.indexOf("request_token") === -1) {
      requestTokenRetry = 0;
    }
    return jhhAPIResponse;
  } catch (err) {
    const statusCode = _.get(err, "response.status");
    const message = _.get(err, "message");
    const responseType = _.get(err, "response.request.responseType");
    const apiErroMessage = _.get(err, "response.data.message", "Something went wrong. Please try again later!");
    
    if (statusCode === 401 && isJHHTokenRequired === true) {
      const restDataObject = {
        previousRest: rest,
        isJHHTokenRequired: isJHHTokenRequired,
        isDeviceDetailsRequired: isDeviceDetailsRequired,
      };
      if (requestTokenCalled === false && requestTokenRetry < 3) {
        awaitTokenPromise = _getRefreshToken();
        requestTokenCalled = true;
        const result = await awaitTokenPromise;
        return await callApiWithRefreshedToken(result, restDataObject);
      } else if (requestTokenCalled === true) {
        const result = await awaitTokenPromise;
        return await callApiWithRefreshedToken(result, restDataObject);
      }else if(requestTokenRetry>=3){
        // const _hasBridgeHelper = await apiErrorIntentHanlder({value: "request limit exceeded", error_code: "401"})
        // if(!_hasBridgeHelper) {
        //   forceLogout();
        // }
        throw err;
      }
    } 
    // else if (statusCode === 412 && isJHHTokenRequired === true) {
    //   const _hasBridgeHelper = await apiErrorIntentHanlder({value: apiErroMessage, error_code: "412"})
    //     if(!_hasBridgeHelper)
    //   forceLogout();
    //   throw err;
    // } else if (statusCode === 410 && isJHHTokenRequired === true) {
    //   const _hasBridgeHelper = await apiErrorIntentHanlder({value: apiErroMessage, error_code: "410"})
    //   if(!_hasBridgeHelper){
    //     if (_getItemFromLocalDecrypted("switchToPrimaryProfile") !== "true") {
    //       _setItemInLocalEncrypted("switchToPrimaryProfile", "true");
    //       window.location.href = `${relativePath}/`;
    //     }
    //   }
    // } 
    else if (statusCode === 403 && isJHHTokenRequired === true) {
      // const _hasBridgeHelper = await apiErrorIntentHanlder({value: apiErroMessage, error_code: "403"})
      // if(!_hasBridgeHelper) {
      //   forceLogout();
      // }
      throw err;
    } else if (API_ERROR_5XX_REGEX.test(statusCode) && isJHHTokenRequired === true && responseType !== "blob") {
      const newErr = {
        response: {
          status: statusCode,
          request: {
            responseType: responseType
          },
          data: {
            message: "Unable to reach server currently. Please try after some time."
          }
        },
        message: message
      }
      throw newErr;
    } else if (message === "Malformed UTF-8 data") {
      // let _hasBridgeHelper = await apiErrorIntentHanlder({value: "Malformed UTF-8 data"})
      // if(!_hasBridgeHelper)
      // forceLogout();
      // forceLogout();
      throw err;
    } else {
      if(!navigator.onLine) {
        // notify("Unable to reach Server, please check your network connection")
      }
      throw err;
    }
  }
};

export const handleInSecureApiCall = async (
  { ...rest }: IMakeInSecureApiCall,
  isDeviceDetailsRequired = false
): Promise<any> => {
  try {
    if (rest.url.length) {
      if (isDeviceDetailsRequired) {
        rest = {
          ...rest,
          dataObj: {
            ...rest.dataObj,
            // ...inputParams(),
          },
          headers: {
            "Content-Type": "application/json",
            ...rest.headers,
          },
        };
      } else {
        rest = {
          ...rest,
          headers: {
            "Content-Type": "application/json",
            ...rest.headers,
          },
        };
      }
    }
    // if(rest.dataObj) {
    //   rest = {
    //     ...rest,
    //     dataObj: _parseDataObj(rest.dataObj)
    //   }
    // }
    const jhhAPIResponse = await _makeInSecureApiCall({ ...rest });
    return jhhAPIResponse;
  } catch (err) {
    throw err;
  }
};

export const accessTokenApiCall = async (clientPublicKey: string | null) => {
  const response = await handleInSecureApiCall({
    url: config.HealthGetTokenUrl,
    method: "post",
    dataObj: {},
    requestBody: { type: Object },
    headers: {
      public_key: clientPublicKey,
    },
  });
  return {
    access_token: response.access_token,
    public_key: response.public_key,
    ttl: response.ttl,
  };
};

const _setBifrostReqToken = async () => {
  const clientKey:string = _initalizeClientPublicKey().toString();
  try {
      bifrostRequestTokenCalled = true;
      awaitBifrostTokenPromise = accessTokenApiCall(clientKey);
      const response: any = await awaitBifrostTokenPromise;
      if (response && response?.access_token && response.public_key && response.ttl) {
        _setDHRefreshLocalItems({...response});
      }
    return response;
  } catch (err) {
    throw err;
  } finally{
    bifrostRequestTokenCalled = false
  }
};

export const handleBifrostApiCall = async (
  { ...rest }: IMakeJHHApiCall,
  isJHHTokenRequired: boolean
): Promise<any> => {
  try {  
    rest = {
      ...rest,
      headers: {
        "Content-Type": "application/json",
        ...rest.headers,
      },
    }

    if (isJHHTokenRequired) {
      let tokenApiResponse;

      if(bifrostRequestTokenCalled) {
        tokenApiResponse = await awaitBifrostTokenPromise;
      } else{
        tokenApiResponse = await _setBifrostReqToken();
      }
      
      rest = {
        ...rest,
        headers: {
          ...rest.headers,
          Authorization: `Bearer ${tokenApiResponse.access_token}`,
        },
      };
    }

    const clonedRest = _.cloneDeep(rest);
    console.log(rest.url, rest.dataObj)
    const bifrostResponse = await _makeBifrostApiCall({ ...clonedRest });
    console.log(rest.url, JSON.parse(bifrostResponse))
    // console.log(rest.url, (bifrostResponse))
    return bifrostResponse;
  } catch (err) {
    const statusCode = _.get(err, "response.status");
    if (statusCode === 403) {
      // notify("Please Refresh the Page");
    } else {
      if (!navigator.onLine) {
        // notify("Unable to reach Server, please check your network connection");
      }
      throw err;
    }
    throw err;
  }
};
